/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Room matches grouped by confirmation status
 * @export
 * @interface ComparisonStatisticsRoomMatchesByStatus
 */
export interface ComparisonStatisticsRoomMatchesByStatus {
    /**
     * 
     * @type {number}
     * @memberof ComparisonStatisticsRoomMatchesByStatus
     */
    confirmed?: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonStatisticsRoomMatchesByStatus
     */
    rejected?: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonStatisticsRoomMatchesByStatus
     */
    pending?: number;
}

/**
 * Check if a given object implements the ComparisonStatisticsRoomMatchesByStatus interface.
 */
export function instanceOfComparisonStatisticsRoomMatchesByStatus(value: object): value is ComparisonStatisticsRoomMatchesByStatus {
    return true;
}

export function ComparisonStatisticsRoomMatchesByStatusFromJSON(json: any): ComparisonStatisticsRoomMatchesByStatus {
    return ComparisonStatisticsRoomMatchesByStatusFromJSONTyped(json, false);
}

export function ComparisonStatisticsRoomMatchesByStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparisonStatisticsRoomMatchesByStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmed': json['confirmed'] == null ? undefined : json['confirmed'],
        'rejected': json['rejected'] == null ? undefined : json['rejected'],
        'pending': json['pending'] == null ? undefined : json['pending'],
    };
}

export function ComparisonStatisticsRoomMatchesByStatusToJSON(json: any): ComparisonStatisticsRoomMatchesByStatus {
    return ComparisonStatisticsRoomMatchesByStatusToJSONTyped(json, false);
}

export function ComparisonStatisticsRoomMatchesByStatusToJSONTyped(value?: ComparisonStatisticsRoomMatchesByStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confirmed': value['confirmed'],
        'rejected': value['rejected'],
        'pending': value['pending'],
    };
}

